import React from "react";
import { Link } from "react-router-dom";
import Image1 from "../../assets/images/time.png";
import Image2 from "../../assets/images/location.png";

import "./events.scss";
export const Events = ({ data }) => {
  return (
    <div className="events-component">
      <div
        className="events-banner"
        style={{ backgroundImage: `url(${data.img})` }}
      >
        <div className="events-date col-md-3 col-4">
          <h1>{data.day}</h1>
          <h2>{data.month}</h2>
        </div>
      </div>
      <div className="events-body">
        <h5>{data.eventsHeading}</h5>
        <div className="flexy flexyM col-md-12">
          <small style={{ flexGrow: 1 }}>
            {" "}
            <img className="" src={Image1} alt="Scholar" width="15%" />
            {data.time}
          </small>
          <small>
            {" "}
            <img className="" src={Image2} alt="Scholar" width="15%" />
            {data.location}
          </small>
        </div>
        <p style={{ height: "100px" }}>{data.eventsDetails}</p>
        <Link className="events-link" to={"/"}>
          LEARN NOW
        </Link>
      </div>
    </div>
  );
};
